window.locales = {
  'de': require('./de.json'),
  'en': require('./en.json'),
  'es': require('./es.json'),
  'fr': require('./fr.json'),
  'it': require('./it.json'),
  'ja': require('./ja.json'),
  'ko': require('./ko.json'),
  'pt_BR': require('./pt_BR.json'),
  'zh_CN': require('./zh_CN.json'),
  'zh_TW': require('./zh_TW.json'),
};
